/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AuthService {

    /**
     * Validates user credentials
     * @param xAccessToken API Token
     * @param requestBody
     * @returns any valid credentials
     * @throws ApiError
     */
    public static postInternalApiWxAuthValidateCredentials(
        xAccessToken?: string,
        requestBody?: {
            email: string;
            password: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal_api/wx/auth/validate_credentials',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `unconfirmed email`,
            },
        });
    }

    /**
     * Invalidates all active server-side sessions for a single user
     * @param xAccessToken API Token
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postInternalApiWxAuthInvalidateSessions(
        xAccessToken?: string,
        requestBody?: {
            /**
             * Account external_id (UUID)
             */
            hire_account_uuid: string;
            /**
             * User wx_external_id or wx_audience_external_id
             */
            user_external_id: string;
            /**
             * Optional; defaults to 'single_user'
             */
            scope?: 'single_user';
        },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal_api/wx/auth/invalidate_sessions',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `unsupported scope`,
                401: `unauthorized`,
                404: `hire_account_uuid does not match the authenticated account`,
            },
        });
    }

    /**
     * Invalidates all active server-side sessions for every user in the account
     * @param xAccessToken API Token
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postInternalApiWxAuthInvalidateAccountSessions(
        xAccessToken?: string,
        requestBody?: {
            /**
             * Account external_id (UUID)
             */
            hire_account_uuid: string;
        },
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal_api/wx/auth/invalidate_account_sessions',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `hire_account_uuid missing`,
                401: `unauthorized`,
                404: `hire_account_uuid does not match the authenticated account`,
            },
        });
    }

}